export enum TransactionType {
  Buy = "buy",
  Sell = "sell",
}

export enum BidStatus {
  Active = "ACTIVE",
  Closed = "CLOSED",
  Rejected = "REJECTED",
  Accepted = "ACCEPTED",
  Pending = "PENDING",
  Cancelled = "CANCELLED",
}

export enum BidRoundStatus {
  Open = "OPEN",
  Closed = "CLOSED",
  Created = "CREATED",
  Completed = "COMPLETED",
  Traded = "TRADED",
}

export enum ErrorCodeEnum {
  INVALID_BID_ID = "E001",
  BID_ROUND_NOT_OPEN = "E002",
  USER_ALREADY_PLACED_BID = "E003",
  BID_ROUND_COMPLETED_UNCHANGEABLE = "E004",
  BID_ROUND_WITH_BIDS_INDELIBLE = "E005",
  FIXED_RATE_BID_SAME_USER_TYPES = "E006",
  INVALID_BID_PRICE = "E007",
  BLOCK_CHAIN_ERROR = "E012",
  PENDING_TRANSACTION_ERROR = "E013",
}

export enum TransactionTypeId {
  BUY = 1,
  SELL = 2,
}

export enum BidRoundType {
  DayAhead = "Day Ahead",
  Monthly = "Monthly",
}

export enum ReportFilterOptions {
  Buyers = "Buyers",
  Sellers = "Sellers",
  Accepted = "Accepted",
  Rejected = "Rejected",
  All = "All",
}
